import { createAction, props } from '@ngrx/store';
import { AssessmentAttempt } from '../models/assessment/assessment-attempt.model';

export const assessmentAttemptCreated = createAction(
  "[Assessment Screen] New Assessment Attempt Created",
  props<{
    userId: string, B
    assessmentId: string,
    courseId: string,
    attempt: AssessmentAttempt
  }>()
);

export const loadAssessmentAttempt = createAction(
  "[Assessment Attempt Effect] Load Assessment Attempt",
  props<{ userId: string, assessmentId: string }>()
);

export const loadAssessmentAttemptSuccess = createAction(
  "[Assessment Attempt Effect] Load Assessment Attempt Success",
  props<{ attempt: AssessmentAttempt }>()
);

export const loadCourseAssessments = createAction(
  "[Assessment Attempt Effect] Load Course Assessments",
  props<{ userId: string, courseId: string }>()
);

export const loadCourseAssessmentsSuccess = createAction(
  "[Assessment Attempt Effect] Load Course Assessments Success",
  props<{ attempts: AssessmentAttempt[] }>()
);
